import React from "react";

/* Text / Heading — token-driven typography primitives.
   They render the correct semantic element and apply the design-system
   typography classes from tokens/typography.css. NO inline fontSize / fontWeight
   / color — that is exactly the consumer debt these replace (REG-378 part 3,
   FR-016). Layout-only style (margin/flex) may still be passed via `style`. */

const TEXT_CLASS = {
  large: "t-p-large",
  regular: "t-p-regular",
  small: "t-p-small",
  mini: "t-p-mini",
  "large-medium": "t-p-large-medium",
  "regular-medium": "t-p-regular-medium",
  "small-medium": "t-p-small-medium",
  "mini-medium": "t-p-mini-medium",
  "regular-bold": "t-p-regular-bold",
  "small-bold": "t-p-small-bold",
  "mini-bold": "t-p-mini-bold",
  caption: "t-caption",
};

export function Heading({ level = 2, as, children, className, style, ...rest }) {
  const Tag = as || `h${level}`;
  const cls = `t-heading-${level}${className ? ` ${className}` : ""}`;
  return (
    <Tag className={cls} style={style} {...rest}>
      {children}
    </Tag>
  );
}

export function Text({ variant = "regular", as = "p", children, className, style, ...rest }) {
  const Tag = as;
  const base = TEXT_CLASS[variant] || TEXT_CLASS.regular;
  const cls = `${base}${className ? ` ${className}` : ""}`;
  return (
    <Tag className={cls} style={style} {...rest}>
      {children}
    </Tag>
  );
}

export default Text;
